<template>
  <div class="login-wrap">
    <h2>
      <img :src="logoUrl" alt="" class="logo-img" />
      <span>{{ sysName }}</span>
    </h2>
    <form ref="formRef" :action="Url" method="post">
      <input type="hidden" name="SAMLRequest" :value="samlRequest" />
    </form>
  </div>
</template>

<script>
import { userImgCode } from 'api/verificationCode'
import { routerAdfs, getMenu, queryTitle } from './api'
import { SET_USER_INFO, SET_MENUS } from 'config/mutation-types/user'
import { SET_SYS_NAME } from 'config/mutation-types/app'
import { mapMutations, mapGetters } from 'vuex'

export default {
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      imgCodeUrl: '',
      loading: false,
      Url: '',
      samlRequest: '',
    }
  },
  mounted() {
    this.getMenu()
    this.getTitle()
    this.getImgCodeUrl()
  },
  computed: {
    ...mapGetters('app', ['logoUrl', 'sysName']),
  },
  methods: {
    ...mapMutations('app', [SET_SYS_NAME]),
    ...mapMutations('user', [SET_USER_INFO, SET_MENUS]),
    async getTitle() {
      try {
        const stamp = new Date().getTime()
        const { data } = await queryTitle(stamp)
        this[SET_SYS_NAME](data)
      } catch (error) {
        console.error(error)
      }
    },
    async getMenu() {
      const res = await getMenu()
      if (res.data.status === false) {
        const res = await routerAdfs()
        this.Url = res.data.ssoUri
        this.samlRequest = res.data.samlRequest
        if (this.Url) {
          window.open(
            `https://stscn.lenovo.com/adfs/ls/IdpInitiatedSignOn.aspx?loginToRp=${res.data.issureValue}`,
            '_self',
          )
        }
      } else {
        this.loading = true
        try {
          const token = res.data.token
          const username = res.data.name
          const menus = res.data.menus
          this[SET_USER_INFO]({
            token,
            username: username,
          })
          this[SET_MENUS](menus)

          const redirectName = this.$route.query.redirect || 'personal'

          await this.$router.push({
            name: redirectName,
          })
        } catch (e) {
          this.getImgCodeUrl()
        }
        this.loading = false
      }
    },
    getImgCodeUrl() {
      this.imgCodeUrl = userImgCode()
    },
  },
}
</script>

<style scoped lang="less">
.login-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: url('./img/bg.png') no-repeat #1890ff;
  background-size: 100%;

  /deep/ .ant-input {
    border-radius: 0;
  }

  /deep/ .ant-btn-lg {
    border-radius: 0;
  }

  h2 {
    margin-top: 150px;
    text-align: center;
    font-size: 44px;
    color: #fff;
    font-weight: bold;
    text-shadow: 0 0 #949697, 0 0 #949697, 1px 0 #949697, 0 2px #949697;
    letter-spacing: 2px;

    img {
      width: 88px;
    }

    span {
      margin-left: 25px;
    }
  }
  .login-form {
    position: relative;
    width: 340px;
    height: 296px;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
  }

  .img-input {
    width: 160px;
  }

  .img_code {
    margin-left: 10px;
  }

  .icon-color {
    color: rgba(0, 0, 0, 0.25);
  }

  .text-div {
    text-align: right;
    margin-top: -12px;
    margin-bottom: 10px;
  }
}
</style>
